var map = {
	"./advisor.svg": 418,
	"./asset.png": 885,
	"./bells.png": 886,
	"./bnb.png": 419,
	"./btc.png": 420,
	"./calandar.png": 887,
	"./coin.png": 888,
	"./currency.png": 889,
	"./dashboard.png": 890,
	"./down.png": 891,
	"./eth.png": 421,
	"./fund.png": 892,
	"./fund.svg": 893,
	"./logo.png": 894,
	"./logo2.png": 422,
	"./logo3.png": 895,
	"./mail.png": 896,
	"./news.png": 897,
	"./overview.svg": 898,
	"./price.png": 899,
	"./price.svg": 900,
	"./report.png": 901,
	"./setting.svg": 902,
	"./settings.png": 903,
	"./social/defipulse.png": 423,
	"./social/discord.svg": 424,
	"./social/discord_white.svg": 259,
	"./social/gitbook.svg": 425,
	"./social/github.svg": 426,
	"./social/medium.svg": 427,
	"./social/telegram.svg": 428,
	"./social/twitter.svg": 429,
	"./up.png": 904,
	"./user.png": 417
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 159;